module.exports = __webpack_public_path__ + "img/hhnm_gallery4.d3b0a574.jpg";